import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";

import "./index.scss"; // Import du fichier SCSS
import { LogoIcon } from "../../../assets/icons/LogoIcon";
import { LogoSimpleIcon } from "../../../assets/icons/LogoSimpleIcon";
const Header = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname); // Initialise avec la route actuelle
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownM, setShowDropdownM] = useState(false);
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/connexion");
    window.scrollTo(0, 0); // Navigue vers la page "About"
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768); // Mobile : ≤ 768px
    };
    handleResize(); // Vérifie la taille au chargement
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
    setShowDropdownM(false);
  };
  const navVariants = {
    hidden: { opacity: 0, x: 100 }, // Départ : Hors écran à droite
    visible: {
      opacity: 1,
      x: 0, // Fin : À sa position d'origine
      transition: { duration: 1, ease: "easeOut" }, // Durée et effet
    },
  };
  return (
    <header className="header-container ">
      <div className="container w-100 d-flex justify-content-between align-items-center">
        {/* Logo Section */}

        {isMobile ? (
          <>
            <div className="logo ">
              <LogoSimpleIcon />
            </div>
            <button onClick={toggleModal} className="icon-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4 6H20V8H4V6ZM7 11H20V13H7V11ZM20 16H4V18H20V16Z"
                  fill="white"
                />
              </svg>
            </button>
          </>
        ) : (
          <nav className="nav-links w-100 d-flex justify-content-between align-items-center">
            <a
              href="/apropos"
              className={`nav-link  ${
                activeMenu === "/apropos" ? "active" : ""
              }`}
            >
              A propos
            </a>

            <div
              className="nav-link dropdown-container"
              onMouseEnter={() => setShowDropdown(true)}
              onMouseLeave={() => setShowDropdown(false)}
            >
              <a
                href="/services"
                className={`nav-link ${
                  activeMenu === "/services" ? "active" : ""
                }`}
                onClick={() => setActiveMenu("/services")}
              >
                Nos Services <BsChevronDown />
              </a>
              {showDropdown && (
                <div className="dropdown-menu1">
                  <a href="/consulting" className="dropdown-item1">
                    Consulting
                  </a>
                  <a href="/developpement" className="dropdown-item1">
                    Développement
                  </a>
                  <a href="/marketing" className="dropdown-item1">
                    Marketing
                  </a>
                  <a href="/design" className="dropdown-item1">
                    Design
                  </a>
                </div>
              )}
            </div>
            <LogoIcon />
            <a
              href="/simulation"
              className={`nav-link  ${
                activeMenu === "/simulation" ? "active" : ""
              }`}
            >
              Simulation
            </a>
            <a
              href="/contact"
              className={`nav-link  ${
                activeMenu === "/contact" ? "active" : ""
              }`}
            >
              Contact
            </a>
            <a
              href="/demandez-devis"
              className={`nav-link  ${
                activeMenu === "/demandez-devis" ? "active" : ""
              }`}
            >
              Demandez un devis
            </a>
            <button className="btn-devis" onClick={handleNavigation}>
              Connexion
            </button>
          </nav>
        )}
        {/* Navigation Links */}
      </div>
      <Modal
        show={showModal}
        onHide={toggleModal}
        dialogClassName="fade-right"
        className="mm-kra"
      >
        <Modal.Body>
          {" "}
          <div className="d-flex justify-content-between align-items-center mb-3 mobile-mo">
            <div className="logo">
              <LogoSimpleIcon />
            </div>
            <button className="close-button" onClick={toggleModal}>
              &#10005;
            </button>
          </div>
          <nav
            className="nav-links d-flex justify-content-center align-items-start mt-5 flex-column "
            initial="hidden" // État initial
            animate="visible" // État final
            variants={navVariants} // Définit les animations
          >
            <a href="/" className="nav-link nav-m mt-3">
              Accueil
            </a>
            <a href="/apropos" className="nav-link nav-m mt-3">
              A propos
            </a>
            <div
              className=" nav-link nav-m mt-3"
              onMouseEnter={() => setShowDropdownM(true)}
              onMouseLeave={() => setShowDropdownM(false)}
            >
              <a href="/services" className="nav-m1">
                Nos Services
                <BsChevronDown />
              </a>
              {showDropdownM && (
                <div className="">
                  <a href="/consulting" className="nav-link nav-m2  mt-3">
                    Consulting
                  </a>
                  <a href="/developpement" className="nav-link nav-m2 mt-3">
                    Développement
                  </a>
                  <a href="/design" className="nav-link nav-m2 mt-3">
                    Design
                  </a>
                  <a href="/marketing" className="nav-link nav-m2 mt-3">
                    Marketing
                  </a>
                </div>
              )}
            </div>
            <a href="/simulation" className="nav-link nav-m mt-3">
              Simulation
            </a>
            <a href="/contact" className="nav-link nav-m mt-3">
              Contact
            </a>
            <a href="/demandez-devis" className="nav-link nav-m mt-3">
              Demandez un devis
            </a>{" "}
            <a href="/connexion" className="nav-link nav-m mt-3">
              Connexion
            </a>{" "}
          </nav>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
